/* /pages/sales-gifting - the demo request form. v1, 8 Oct 2026.

   The demo is gated (Glen, 8 Oct 2026): nobody gets a demo link from this page.
   A request goes to two places, exactly as the Request an invite form does:

     app.rockkt.com/api/invite-request   the RECORD. A row in Rockkt Admin >
                                         Studio Invites, the same route the app's
                                         own /demo page uses for demo requests.
                                         The note starts "Managed demo request" so
                                         it is not mistaken for a Studio Free ask:
                                         approve it by sending a single-use Online
                                         demo code, NOT with the Invite button.
     Shopify /contact                    the NUDGE. An email to the shop inbox.

   Google Ads click ids and utm tags on the landing URL are copied into the note,
   so a request can be traced back to the campaign. Nothing else is collected. */
(function () {
  var form = document.getElementById('sgDemo');
  if (!form) return;

  var params = new URLSearchParams(location.search);
  var tags = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid']
    .filter(function (k) { return params.get(k); })
    .map(function (k) { return k + '=' + params.get(k).slice(0, 80); });

  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function mark(id, bad) { var el = document.getElementById(id); if (el) el.closest('label').classList.toggle('err', bad); return !bad; }

  function shopifyContact(fields) {
    try {
      var body = ['form_type=contact', 'utf8=%E2%9C%93'];
      for (var k in fields) body.push('contact[' + encodeURIComponent(k) + ']=' + encodeURIComponent(fields[k] || ''));
      fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.join('&') }).catch(function () {});
    } catch (e) {}
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = form.querySelector('.msg');
    msg.hidden = true;
    if (val('sgHp')) return;

    var name = val('sgName'), email = val('sgEmail'), company = val('sgCompany');
    var ok = mark('sgName', !name);
    ok = mark('sgEmail', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) && ok;
    ok = mark('sgCompany', !company) && ok;
    var consent = document.getElementById('sgConsent');
    consent.closest('label').classList.toggle('err', !consent.checked);
    if (!consent.checked) ok = false;
    if (!ok) return;

    var role = val('sgRole'), team = val('sgTeam'), reach = val('sgReach');
    var note = ['Managed demo request from /pages/sales-gifting',
      role ? 'Role: ' + role : '', team ? 'Team size: ' + team : '',
      reach ? 'Wants to reach: ' + reach : '', tags.length ? 'Source: ' + tags.join(', ') : '']
      .filter(Boolean).join(' · ');

    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Sending…';

    shopifyContact({ name: name, email: email, Company: company, Role: role, 'Team size': team,
      'Request type': 'Managed demo request (sales-gifting page)', body: reach || '(no message)', Source: tags.join(', ') });

    fetch('https://app.rockkt.com/api/invite-request', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name, email: email, company: company, note: note })
    }).then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
      .then(function (j) {
        if (j && j.ok) {
          form.querySelectorAll('input,select,textarea,button').forEach(function (el) { el.disabled = true; });
          msg.className = 'msg ok';
          msg.textContent = 'Thanks, ' + name.split(' ')[0] + '. Your request is with the Rockkt team, and we will email ' + email + ' a link to your demo.';
        } else {
          throw new Error((j && (j.message || j.error)) || 'failed');
        }
        msg.hidden = false;
      })
      .catch(function () {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Request a free demo';
        msg.className = 'msg bad';
        msg.textContent = 'That did not send. Please try again, or email hello@rockkt.com.';
        msg.hidden = false;
      });
  });
})();
